import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useState, useEffect, useReducer, useMemo } from "react";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */

export function useListData(options) {
  var _options$initialItems = options.initialItems,
      initialItems = _options$initialItems === void 0 ? [] : _options$initialItems,
      initialSelectedKeys = options.initialSelectedKeys,
      _options$getKey = options.getKey,
      getKey = _options$getKey === void 0 ? function (item) {
    return item.id || item.key;
  } : _options$getKey;

  var _useState = useState({
    items: initialItems,
    selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || [])
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return _babelRuntimeHelpersEsmExtends({}, state, $b778f1542e2cf1e9d9f1c7276a173aec$export$createListActions({
    getKey: getKey
  }, setState), {
    getItem: function getItem(key) {
      return state.items.find(function (item) {
        return getKey(item) === key;
      });
    }
  });
}

function $b778f1542e2cf1e9d9f1c7276a173aec$var$insert(state, index) {
  for (var _len = arguments.length, values = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    values[_key - 2] = arguments[_key];
  }

  return _babelRuntimeHelpersEsmExtends({}, state, {
    items: [].concat(_toConsumableArray(state.items.slice(0, index)), values, _toConsumableArray(state.items.slice(index)))
  });
}

function $b778f1542e2cf1e9d9f1c7276a173aec$export$createListActions(opts, dispatch) {
  var getKey = opts.getKey;
  return {
    setSelectedKeys: function setSelectedKeys(selectedKeys) {
      dispatch(function (state) {
        return _babelRuntimeHelpersEsmExtends({}, state, {
          selectedKeys: selectedKeys
        });
      });
    },
    insert: function insert(index) {
      for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        values[_key2 - 1] = arguments[_key2];
      }

      dispatch(function (state) {
        return $b778f1542e2cf1e9d9f1c7276a173aec$var$insert.apply(void 0, [state, index].concat(values));
      });
    },
    insertBefore: function insertBefore(key) {
      for (var _len3 = arguments.length, values = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        values[_key3 - 1] = arguments[_key3];
      }

      dispatch(function (state) {
        var index = state.items.findIndex(function (item) {
          return getKey(item) === key;
        });

        if (index === -1) {
          return;
        }

        return $b778f1542e2cf1e9d9f1c7276a173aec$var$insert.apply(void 0, [state, index].concat(values));
      });
    },
    insertAfter: function insertAfter(key) {
      for (var _len4 = arguments.length, values = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        values[_key4 - 1] = arguments[_key4];
      }

      dispatch(function (state) {
        var index = state.items.findIndex(function (item) {
          return getKey(item) === key;
        });

        if (index === -1) {
          return;
        }

        return $b778f1542e2cf1e9d9f1c7276a173aec$var$insert.apply(void 0, [state, index + 1].concat(values));
      });
    },
    prepend: function prepend() {
      for (var _len5 = arguments.length, values = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        values[_key5] = arguments[_key5];
      }

      dispatch(function (state) {
        return $b778f1542e2cf1e9d9f1c7276a173aec$var$insert.apply(void 0, [state, 0].concat(values));
      });
    },
    append: function append() {
      for (var _len6 = arguments.length, values = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        values[_key6] = arguments[_key6];
      }

      dispatch(function (state) {
        return $b778f1542e2cf1e9d9f1c7276a173aec$var$insert.apply(void 0, [state, state.items.length].concat(values));
      });
    },
    remove: function remove() {
      for (var _len7 = arguments.length, keys = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        keys[_key7] = arguments[_key7];
      }

      dispatch(function (state) {
        var keySet = new Set(keys);
        var items = state.items.filter(function (item) {
          return !keySet.has(getKey(item));
        });
        var selection = new Set(state.selectedKeys);

        var _iterator = _createForOfIteratorHelper(keys),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            selection.delete(key);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return _babelRuntimeHelpersEsmExtends({}, state, {
          items: items,
          selectedKeys: selection
        });
      });
    },
    removeSelectedItems: function removeSelectedItems() {
      dispatch(function (state) {
        if (state.selectedKeys === 'all') {
          return _babelRuntimeHelpersEsmExtends({}, state, {
            items: [],
            selectedKeys: new Set()
          });
        }

        var selectedKeys = state.selectedKeys;
        var items = state.items.filter(function (item) {
          return !selectedKeys.has(getKey(item));
        });
        return _babelRuntimeHelpersEsmExtends({}, state, {
          items: items,
          selectedKeys: new Set()
        });
      });
    },
    move: function move(key, toIndex) {
      dispatch(function (state) {
        var index = state.items.findIndex(function (item) {
          return getKey(item) === key;
        });

        if (index === -1) {
          return state;
        }

        var copy = state.items.slice();

        var _copy$splice = copy.splice(index, 1),
            _copy$splice2 = _slicedToArray(_copy$splice, 1),
            item = _copy$splice2[0];

        copy.splice(toIndex, 0, item);
        return _babelRuntimeHelpersEsmExtends({}, state, {
          items: copy
        });
      });
    },
    update: function update(key, newValue) {
      dispatch(function (state) {
        var index = state.items.findIndex(function (item) {
          return getKey(item) === key;
        });

        if (index === -1) {
          return state;
        }

        return _babelRuntimeHelpersEsmExtends({}, state, {
          items: [].concat(_toConsumableArray(state.items.slice(0, index)), [newValue], _toConsumableArray(state.items.slice(index + 1)))
        });
      });
    }
  };
}

function $ebfe0ef2c160f1de1367205924a0b01e$var$reducer(data, action) {
  var _action$sortDescripto, _action$selectedKeys, _action$sortDescripto2, _action$selectedKeys2, _action$sortDescripto3;

  switch (data.state) {
    case 'idle':
    case 'error':
      switch (action.type) {
        case 'loading':
        case 'loadingMore':
        case 'sorting':
          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: action.type,
            // Reset items to an empty list if loading, but not when sorting.
            items: action.type === 'loading' ? [] : data.items,
            sortDescriptor: (_action$sortDescripto = action.sortDescriptor) != null ? _action$sortDescripto : data.sortDescriptor,
            abortController: action.abortController
          });

        case 'update':
          return _babelRuntimeHelpersEsmExtends({}, data, action.updater(data));

        case 'success':
        case 'error':
          return data;

        default:
          throw new Error("Invalid action \"" + action.type + "\" in state \"" + data.state + "\"");
      }

    case 'loading':
    case 'sorting':
      switch (action.type) {
        case 'success':
          // Ignore if there is a newer abortcontroller in state.
          // This means that multiple requests were going at once.
          // We want to take only the latest result.
          if (action.abortController !== data.abortController) {
            return data;
          }

          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: 'idle',
            items: _toConsumableArray(action.items),
            selectedKeys: new Set((_action$selectedKeys = action.selectedKeys) != null ? _action$selectedKeys : data.selectedKeys),
            sortDescriptor: (_action$sortDescripto2 = action.sortDescriptor) != null ? _action$sortDescripto2 : data.sortDescriptor,
            abortController: null,
            cursor: action.cursor
          });

        case 'error':
          if (action.abortController !== data.abortController) {
            return data;
          }

          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: 'error',
            error: action.error,
            abortController: null
          });

        case 'loading':
        case 'loadingMore':
        case 'sorting':
          // We're already loading, and another load was triggered at the same time.
          // We need to abort the previous load and start a new one.
          data.abortController.abort();
          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: action.type,
            // Reset items to an empty list if loading, but not when sorting.
            items: action.type === 'loading' ? [] : data.items,
            abortController: action.abortController
          });

        default:
          throw new Error("Invalid action \"" + action.type + "\" in state \"" + data.state + "\"");
      }

    case 'loadingMore':
      switch (action.type) {
        case 'success':
          // Append the new items
          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: 'idle',
            items: [].concat(_toConsumableArray(data.items), _toConsumableArray(action.items)),
            selectedKeys: new Set([].concat(_toConsumableArray(data.selectedKeys), _toConsumableArray((_action$selectedKeys2 = action.selectedKeys) != null ? _action$selectedKeys2 : []))),
            sortDescriptor: (_action$sortDescripto3 = action.sortDescriptor) != null ? _action$sortDescripto3 : data.sortDescriptor,
            abortController: null,
            cursor: action.cursor
          });

        case 'error':
          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: 'error',
            error: action.error
          });

        case 'loading':
        case 'sorting':
          // We're already loading more, and another load was triggered at the same time.
          // We need to abort the previous load more and start a new one.
          data.abortController.abort();
          return _babelRuntimeHelpersEsmExtends({}, data, {
            state: 'loading',
            // Reset items to an empty list if loading, but not when sorting.
            items: action.type === 'loading' ? [] : data.items,
            abortController: action.abortController
          });

        default:
          throw new Error("Invalid action \"" + action.type + "\" in state \"" + data.state + "\"");
      }

    default:
      throw new Error("Invalid state \"" + data.state + "\"");
  }
}
/**
 * Manages state for an immutable async loaded list data structure, and provides convenience methods to
 * update the data over time. Manages loading and error states, pagination, and sorting.
 */


export function useAsyncList(options) {
  var load = options.load,
      _sort = options.sort,
      initialSelectedKeys = options.initialSelectedKeys,
      initialSortDescriptor = options.initialSortDescriptor,
      _options$getKey2 = options.getKey,
      getKey = _options$getKey2 === void 0 ? function (item) {
    return item.id || item.key;
  } : _options$getKey2;

  var _useReducer = useReducer($ebfe0ef2c160f1de1367205924a0b01e$var$reducer, {
    state: 'idle',
    error: null,
    items: [],
    selectedKeys: new Set(initialSelectedKeys),
    sortDescriptor: initialSortDescriptor
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      data = _useReducer2[0],
      dispatch = _useReducer2[1];

  var dispatchFetch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, fn) {
      var abortController, _action$sortDescripto4, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              abortController = new AbortController();
              _context.prev = 1;
              dispatch(_babelRuntimeHelpersEsmExtends({}, action, {
                abortController: abortController
              }));
              _context.next = 5;
              return fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: (_action$sortDescripto4 = action.sortDescriptor) != null ? _action$sortDescripto4 : data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === 'loadingMore' ? data.cursor : null
              });

            case 5:
              response = _context.sent;
              dispatch(_babelRuntimeHelpersEsmExtends({
                type: 'success'
              }, response, {
                abortController: abortController
              }));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              dispatch({
                type: 'error',
                error: _context.t0,
                abortController: abortController
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function dispatchFetch(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    dispatchFetch({
      type: 'loading'
    }, load); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return _babelRuntimeHelpersEsmExtends({
    items: data.items,
    selectedKeys: data.selectedKeys,
    sortDescriptor: data.sortDescriptor,
    isLoading: data.state === 'loading' || data.state === 'loadingMore' || data.state === 'sorting',
    error: data.error,
    getItem: function getItem(key) {
      return data.items.find(function (item) {
        return getKey(item) === key;
      });
    },
    reload: function reload() {
      dispatchFetch({
        type: 'loading'
      }, load);
    },
    loadMore: function loadMore() {
      // Ignore if already loading more.
      if (data.state === 'loadingMore' || data.cursor == null) {
        return;
      }

      dispatchFetch({
        type: 'loadingMore'
      }, load);
    },
    sort: function sort(sortDescriptor) {
      dispatchFetch({
        type: 'sorting',
        sortDescriptor: sortDescriptor
      }, _sort || load);
    }
  }, $b778f1542e2cf1e9d9f1c7276a173aec$export$createListActions(_babelRuntimeHelpersEsmExtends({}, options, {
    getKey: getKey
  }), function (fn) {
    dispatch({
      type: 'update',
      updater: fn
    });
  }));
}
/**
 * Manages state for an immutable tree data structure, and provides convenience methods to
 * update the data over time.
 */

export function useTreeData(options) {
  var _options$initialItems2 = options.initialItems,
      initialItems = _options$initialItems2 === void 0 ? [] : _options$initialItems2,
      initialSelectedKeys = options.initialSelectedKeys,
      _options$getKey3 = options.getKey,
      getKey = _options$getKey3 === void 0 ? function (item) {
    return item.id || item.key;
  } : _options$getKey3,
      _options$getChildren = options.getChildren,
      getChildren = _options$getChildren === void 0 ? function (item) {
    return item.children || [];
  } : _options$getChildren;
  var map = useMemo(function () {
    return new Map();
  }, []); // We only want to compute this on initial render.
  // eslint-disable-next-line react-hooks/exhaustive-deps

  var initialNodes = useMemo(function () {
    return buildTree(initialItems);
  }, []);

  var _useState3 = useState(initialNodes),
      _useState4 = _slicedToArray(_useState3, 2),
      items = _useState4[0],
      setItems = _useState4[1];

  var _useState5 = useState(new Set(initialSelectedKeys || [])),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedKeys = _useState6[0],
      setSelectedKeys = _useState6[1];

  function buildTree(initialItems, parentKey) {
    return initialItems.map(function (item) {
      var node = {
        key: getKey(item),
        parentKey: parentKey,
        value: item,
        children: null
      };
      node.children = buildTree(getChildren(item), node.key);
      map.set(node.key, node);
      return node;
    });
  }

  function updateTree(items, key, update) {
    var node = map.get(key);

    if (!node) {
      return items;
    } // Create a new node. If null, then delete the node, otherwise replace.


    var newNode = update(node);

    if (newNode == null) {
      deleteNode(node);
    } else {
      map.set(key, newNode);
    } // Walk up the tree and update each parent to refer to the new chilren.


    while (node.parentKey) {
      var nextParent = map.get(node.parentKey);
      var copy = {
        key: nextParent.key,
        parentKey: nextParent.parentKey,
        value: nextParent.value,
        children: null
      };
      var children = nextParent.children;

      if (newNode == null) {
        children = children.filter(function (c) {
          return c !== node;
        });
      }

      copy.children = children.map(function (child) {
        if (child === node) {
          return newNode;
        }

        return child;
      });
      map.set(copy.key, copy);
      newNode = copy;
      node = nextParent;
    }

    if (newNode == null) {
      items = items.filter(function (c) {
        return c !== node;
      });
    }

    return items.map(function (item) {
      if (item === node) {
        return newNode;
      }

      return item;
    });
  }

  function deleteNode(node) {
    map.delete(node.key);

    var _iterator2 = _createForOfIteratorHelper(node.children),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var child = _step2.value;
        deleteNode(child);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return {
    items: items,
    selectedKeys: selectedKeys,
    setSelectedKeys: setSelectedKeys,
    getItem: function getItem(key) {
      return map.get(key);
    },
    insert: function insert(parentKey, index) {
      for (var _len = arguments.length, values = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        values[_key - 2] = arguments[_key];
      }

      setItems(function (items) {
        var nodes = buildTree(values, parentKey); // If parentKey is null, insert into the root.

        if (parentKey == null) {
          return [].concat(_toConsumableArray(items.slice(0, index)), _toConsumableArray(nodes), _toConsumableArray(items.slice(index)));
        } // Otherwise, update the parent node and its ancestors.


        return updateTree(items, parentKey, function (parentNode) {
          return {
            key: parentNode.key,
            parentKey: parentNode.parentKey,
            value: parentNode.value,
            children: [].concat(_toConsumableArray(parentNode.children.slice(0, index)), _toConsumableArray(nodes), _toConsumableArray(parentNode.children.slice(index)))
          };
        });
      });
    },
    insertBefore: function insertBefore(key) {
      var node = map.get(key);

      if (!node) {
        return;
      }

      var parentNode = map.get(node.parentKey);
      var nodes = parentNode ? parentNode.children : items;
      var index = nodes.indexOf(node);

      for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        values[_key2 - 1] = arguments[_key2];
      }

      this.insert.apply(this, [parentNode == null ? void 0 : parentNode.key, index].concat(values));
    },
    insertAfter: function insertAfter(key) {
      var node = map.get(key);

      if (!node) {
        return;
      }

      var parentNode = map.get(node.parentKey);
      var nodes = parentNode ? parentNode.children : items;
      var index = nodes.indexOf(node);

      for (var _len3 = arguments.length, values = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        values[_key3 - 1] = arguments[_key3];
      }

      this.insert.apply(this, [parentNode == null ? void 0 : parentNode.key, index + 1].concat(values));
    },
    prepend: function prepend(parentKey) {
      for (var _len4 = arguments.length, values = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        values[_key4 - 1] = arguments[_key4];
      }

      this.insert.apply(this, [parentKey, 0].concat(values));
    },
    append: function append(parentKey) {
      for (var _len5 = arguments.length, values = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        values[_key5 - 1] = arguments[_key5];
      }

      if (parentKey == null) {
        this.insert.apply(this, [null, items.length].concat(values));
      } else {
        var parentNode = map.get(parentKey);

        if (!parentNode) {
          return;
        }

        this.insert.apply(this, [parentKey, parentNode.children.length].concat(values));
      }
    },
    remove: function remove() {
      var newItems = items;

      for (var _len6 = arguments.length, keys = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        keys[_key6] = arguments[_key6];
      }

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        newItems = updateTree(newItems, key, function () {
          return null;
        });
      }

      setItems(newItems);
      var selection = new Set(selectedKeys);

      var _iterator3 = _createForOfIteratorHelper(selectedKeys),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _key8 = _step3.value;

          if (!map.has(_key8)) {
            selection.delete(_key8);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      setSelectedKeys(selection);
    },
    removeSelectedItems: function removeSelectedItems() {
      this.remove.apply(this, _toConsumableArray(selectedKeys));
    },
    move: function move(key, toParentKey, index) {
      setItems(function (items) {
        var node = map.get(key);

        if (!node) {
          return items;
        }

        items = updateTree(items, key, function () {
          return null;
        });
        return updateTree(items, toParentKey, function (parentNode) {
          return {
            key: parentNode.key,
            parentKey: parentNode.parentKey,
            value: parentNode.value,
            children: [].concat(_toConsumableArray(parentNode.children.slice(0, index)), [node], _toConsumableArray(parentNode.children.slice(index)))
          };
        });
      });
    },
    update: function update(oldKey, newValue) {
      setItems(function (items) {
        return updateTree(items, oldKey, function (oldNode) {
          var node = {
            key: oldNode.key,
            parentKey: oldNode.key,
            value: newValue,
            children: null
          };
          node.children = buildTree(getChildren(newValue), node.key);
          return node;
        });
      });
    }
  };
}